import { ResponseType } from 'axios';
import { axiosApiInstance, httpAxiosClient } from 'src/utils/axiosInstances';
import { parseApiError } from 'src/utils/apiError';

const ABSOLUTE_URL = /^https?:\/\//i;

export type ApiResult<T = unknown> = {
  success: boolean;
  data?: T;
  error?: string;
  status?: number;
  headers?: any;
};

export type ApiRequestConfig = {
  url: string;
  method: 'get' | 'post' | 'put' | 'delete';
  body?: any;
  params?: any;
  headers?: any;
  responseType?: ResponseType;
  signal?: AbortSignal;
};

// Executes a request against the versioned Blimp API. Never throws, never silently
// swallows: errors are always parsed. 401 + token refresh are handled by the
// interceptor on blimpAxiosClient.api — this function does not duplicate that logic.
export const apiRequest = async <T = unknown>(config: ApiRequestConfig): Promise<ApiResult<T>> => {
  const client = ABSOLUTE_URL.test(config.url) ? httpAxiosClient : axiosApiInstance;
  try {
    const res = await client.request<T>({
      url: config.url,
      method: config.method,
      data: config.body,
      params: config.params,
      headers: config.headers,
      responseType: config.responseType,
      signal: config.signal,
    });
    return { success: true, data: res.data, status: res.status, headers: res.headers };
  } catch (err: any) {
    return {
      success: false,
      error: await parseApiError(err),
      status: err?.response?.status,
      headers: err?.response?.headers,
    };
  }
};
